export default "__VITE_ASSET__DtkSmSdZ__"